<script lang="ts">
    import { Label, Input, Textarea, Spinner } from "flowbite-svelte";
    import { send_email } from "../../service/http_calls";
    import { toast } from "$service/toast";
    import { onMount } from "svelte";

    let loading = false;
    let email = "";
    let message = "";

    async function handleSubmit() {
        loading = true;
        await send_email(email, "", message);
        loading = false;
        toast("Thanks for contacting us! We will get back to you soon.", "success");
    }

    onMount(() => {
        const script = document.createElement("script");
        script.src = "https://assets.calendly.com/assets/external/widget.js";
        script.async = true;
        document.head.appendChild(script);
    });
</script>

<div class="max-w-6xl mx-auto px-6 md:px-16">
    <div class="text-center mb-12">
        <h2 class="text-[38px] font-semibold text-navy">Empower your R&D technical work with AI</h2>
        <p class="text-purple-sub mt-4 text-lg">Would you like a quick demo?</p>
    </div>

    <div class="grid md:grid-cols-2 gap-10 items-stretch">
        <!-- Calendly inline widget -->
        <div
            class="calendly-inline-widget w-full rounded-2xl overflow-hidden"
            data-url="https://calendly.com/shilin-smartclaim/smartclaim"
            style="min-width: 320px; height: 700px;"
        ></div>

        <!-- Contact form -->
        <div class="bg-white border border-card-border rounded-2xl p-10 shadow-sm flex flex-col">
            <h3 class="text-2xl font-semibold text-navy mb-8">Or send us a message</h3>
            <form class="space-y-5">
                <div>
                    <Label for="email" class="block mb-2 text-sm font-medium text-gray-700">Your email</Label>
                    <Input
                        id="email"
                        name="email"
                        placeholder="name@email.com"
                        bind:value={email}
                        required
                    />
                </div>
                <div>
                    <Label for="message" class="block mb-2 text-sm font-medium text-gray-700">Message</Label>
                    <Textarea
                        class="h-36"
                        id="message"
                        name="message"
                        placeholder="Leave a comment..."
                        bind:value={message}
                    />
                </div>
                {#if loading}
                    <div class="flex justify-center py-2">
                        <Spinner />
                    </div>
                {:else}
                    <button
                        type="button"
                        on:click={handleSubmit}
                        class="w-full bg-navy text-white py-3.5 rounded-full font-semibold hover:opacity-90 transition"
                    >
                        Send
                    </button>
                {/if}
            </form>
        </div>
    </div>
</div>
